//=================|| CSS FILES ||====================//
import 'vuetify/dist/vuetify.css'               //vuetify scss
import 'slick-carousel/slick/slick.css'         //slick carousel scss
import 'slick-carousel/slick/slick-theme.css'   //slick theme scss
import 'vue-snotify/styles/dark.css';           //snotify scss
import "nprogress/nprogress.css"                //loader scss
import 'Assets/css/font-awesome.min.css'        //font awesome scss
import 'Assets/scss/style.scss'                 //style scss